module.exports = __webpack_public_path__ + "static/media/chart_passive.4e1b28ea.jpg";